import {Button, styled} from "@mui/material";

export const NewCardButton = styled(Button)(({theme}) => ({
    minWidth: '290px',
    display: 'flex',
    flexDirection: 'row',
    padding: '0.5rem 0.75rem',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '15px',

    border: `2px solid ${theme.barekam.orderList.border}`,
    '& img': {
        marginRight: '0.75rem'
    }
}));
export const NewCardButtonSelected = styled(NewCardButton)(({theme}) => ({
    backgroundColor: theme.barekam.recipient.buttons.add.backgroundColor,
    color: theme.barekam.recipient.buttons.add.color,

    '&:hover': {
        backgroundColor: theme.barekam.recipient.buttons.add.backgroundColor,
    },
}));